import { audiUSAModelRegistry } from './tracker/constants.js';

export const tileBaseObj = {
  isDefault: false, // NOTE: PCT ADDITION
  CTA: {
    text: 'Explore',
    href: '#',
    variant: 'primary',
    linkType: 'fullTile',
    openIn: 'New tab',
    newWindow: false,
  },
  disclaimers: [],
  fade: {
    color: '#000000',
    direction: 'bottom',
    height: '70%',
    opacity: '60%',
  },
  fadeEnabled: true,
  heading: {
    text: 'Content Tiles',
    variant: 'order1',
    htmlTag: 'h2',
  },
  horizontalAlignment: 'center',
  horizontalAlignmentSmall: 'center',
  icon: '',
  linkType: 'fullTile', // Deprecated
  logo: {
    alt: '',
    src: '',
    srcAsset: { assetValue: '' },
    heights: {
      xs: '18',
      s: '18',
      m: '24',
      l: '36',
      xl: '48',
      xxl: '60',
    },
  },
  media: {
    assetType: 'image',
    imageEnabled: true,
    videoEnabled: false,
    newWindow: false,
    fadeEnabled: true,
    zoomEnabled: true,
    fade: {
      color: '#000000',
      direction: 'bottom',
      height: '70%',
      opacity: '0.6',
    },
    image: {
      alt: 'q4 etron',
      srcSet: [
        {
          bp: 'xxl',
          src: 'https://uploads.audi-mediacenter.com/system/production/media/119270/images/6ed36bf38ce6c5873b81406e0d7c0f868048469d/A234526_web_1440.jpg',
        },
        {
          bp: 'xl',
          src: 'https://uploads.audi-mediacenter.com/system/production/media/119270/images/6ed36bf38ce6c5873b81406e0d7c0f868048469d/A234526_web_1440.jpg',
        },
        {
          bp: 'l',
          src: 'https://uploads.audi-mediacenter.com/system/production/media/119270/images/6ed36bf38ce6c5873b81406e0d7c0f868048469d/A234526_web_1440.jpg',
        },
        {
          bp: 'm',
          src: 'https://uploads.audi-mediacenter.com/system/production/media/119264/images/7faded3e7869b641611eee8634094e0ff7bfb9d6/A234520_web_1440.jpg',
        },
        {
          bp: 's',
          src: 'https://uploads.audi-mediacenter.com/system/production/media/119264/images/7faded3e7869b641611eee8634094e0ff7bfb9d6/A234520_web_1440.jpg',
        },
        {
          bp: 'xs',
          src: 'https://uploads.audi-mediacenter.com/system/production/media/119264/images/7faded3e7869b641611eee8634094e0ff7bfb9d6/A234520_web_1440.jpg',
        },
      ],
    },
    video: {
      alt: '',
      autoplay: false,
      loop: false,
      srcs: {
        xs: {
          src: '',
          poster: '',
        },
        s: {
          src: '',
          poster: '',
        },
        m: {
          src: '',
          poster: '',
        },
        l: {
          src: '',
          poster: '',
        },
        xl: {
          src: '',
          poster: '',
        },
        xxl: {
          src: '',
          poster: '',
        },
      },
    },
  },
  subHeading: {
    text: '',
    variant: 'order3',
    htmlTag: 'p',
  },
  theme: 'dark',
  verticalAlignment: 'bottom',
  verticalAlignmentSmall: 'bottom',
  wltpKeys: [],
  zoomEnabled: true,
};
const getMedia = ({ small, large = small, alt = 'Audi vehicle' }) => {
  const { media: baseMedia } = tileBaseObj;
  const toReturn = {
    media: {
      ...baseMedia,
    },
    mediaAsset: {
      assetType: 'image',
      alt,
      imageUrlSmall: {
        assetValue: small,
      },
      imageUrlLarge: {
        assetValue: large,
      },
    },
  };
  toReturn.media.image = {
    alt,
    srcSet: [
      {
        bp: 'xxl',
        src: large,
      },
      {
        bp: 'xl',
        src: large,
      },
      {
        bp: 'lg',
        src: large,
      },
      {
        bp: 'md',
        src: small,
      },
      {
        bp: 'sm',
        src: small,
      },
      {
        bp: 'xs',
        src: small,
      },
    ],
  };
  return toReturn;
};
const getCTA = (CTA) => {
  return {
    ...tileBaseObj.CTA,
    ...CTA,
  };
};
const getHeading = (text) => {
  return {
    text,
    variant: 'order1',
    htmlTag: 'h1',
  };
};

export const defaultTiles = [
  audiUSAModelRegistry['all-new-a5'].heading,
  audiUSAModelRegistry['a6-sportback-e-tron'].heading,
  audiUSAModelRegistry['q6-e-tron'].heading,
];
export const tiles = Object.values(audiUSAModelRegistry).map(({ heading, imageSmall, mlpUrl }) => {
  return {
    ...tileBaseObj,
    CTA: getCTA({
      href: mlpUrl,
    }),
    heading: getHeading(heading),
    isDefault: defaultTiles.includes(heading),
    alt: heading,
    ...getMedia({
      small: imageSmall,
    }),
  };
});

export const personalizationData = {
  layout: {
    name: 'Basic - 3x1',
    size: 'tall',
  },
  tiles,
};

export const personalizationFeaturedTile = {
  ...tileBaseObj,
  isEnabled: true,
  CTA: getCTA({
    href: 'https://www.audiusa.com/en/models/a7/rs7/2025/overview/',
    variant: 'secondary',
    text: 'Learn More',
  }),
  heading: getHeading('❗Audi RS 7 Performance❗'),
  ...getMedia({
    small:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-P1-MY25-RS-7-performance-Front-Profile-Driving-4359.jpg',
  }),
};
